import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ko', 'zh-CN'],
    debug: false,

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lightway-language',
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-cache',
      },
    },

    ns: ['translation', 'suggestions', 'faq'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
